import { render, staticRenderFns } from "./CreatePromoExpiration.vue?vue&type=template&id=b7f7413a"
import script from "./CreatePromoExpiration.vue?vue&type=script&lang=js"
export * from "./CreatePromoExpiration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports